function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    x1: 0.6,
    y1: 1,
    x2: 12,
    y2: 1,
    style: {
      stroke: "rgb(163, 230, 53)",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 12.7,
    y2: 12.7,
    style: {
      stroke: "rgb(163, 230, 53)",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 0,
    y2: 24,
    style: {
      stroke: "rgb(163, 230, 53)",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 11.4,
    x2: 11,
    y2: 24,
    style: {
      stroke: "rgb(163, 230, 53)",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 0,
    x2: 23,
    y2: 12.6,
    style: {
      stroke: "rgb(163, 230, 53)",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.6,
    y1: 23,
    x2: 12,
    y2: 23,
    style: {
      stroke: "rgb(163, 230, 53)",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7b4a4123e61d0f86215ee09a3ab1168d.svg";
export { ForwardRef as ReactComponent };